module.exports = __webpack_public_path__ + "img/IMG_6558_FoamcoreMatted.e7c80ba1.jpg";